import React, { Suspense } from 'react'
import { useRoutes, Navigate } from 'react-router-dom'
import publicRoutes from './public-routes'
import memberRoutes from './member-routes'
import companyRoutes from './company-routes'
import adminRoutes from './admin-routes'
import recruitmentRoutes from './recruitment-routes'
import interviewRoutes from './interview-routes'
import settingsRoutes from './settings-routes'

const Page404 = React.lazy(() => import('_containers/404'))
const AfterLogin = React.lazy(() => import('_root/containers/after-login'))
import * as url from '_routes/url-names'
import AuthRoute from '_routes/authenticated-route'

const allRoutes = [
  ...publicRoutes,
  ...memberRoutes,
  ...companyRoutes,
  ...adminRoutes,
  ...recruitmentRoutes,
  ...interviewRoutes,
  ...settingsRoutes,
  { path: url.COMPANY, element: <AuthRoute component={AfterLogin} /> },
  { path: "/medlem", element: <Navigate to="/konto" replace /> },
  { path: '*', element: <Page404 /> }
]

export default function AppRoutes() {
  const routes = useRoutes(allRoutes)
  return (
    <Suspense>
      {routes}
    </Suspense>
  )
}
